import React, { useState } from 'react'

export const FilterContext = React.createContext()

export const withFilterContext = Component => props => {
	const [filterState, setFilterState] = useState({})
	const value = {
		...filterState,
		setFilter(sectionName, filterValue) {
			setFilterState({
				...filterState,
				[sectionName]: filterValue
			})
		}
	}
	return(
		<FilterContext.Provider value={value}>
			<Component {...props}/>
		</FilterContext.Provider>
	)
}
